import React from 'react';
import NCZISetupGeneralInformation, {
	NCZISetupGeneralInformationData,
} from './NCZISetupGeneralInformation';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	onSuccess: (data: NCZISetupGeneralInformationData) => void;
}

const NCZISetupGeneralInformationModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='Všeobecné informace' size={Size.MD}>
			<NCZISetupGeneralInformation onSuccess={props.onSuccess} />
		</BaseModal>
	);
};

export default NCZISetupGeneralInformationModal;
